import type { TPageTranslations } from '@crehana/i18n';

import { CANDIDATE_FORM } from './constants';
import type { TKeys } from './types';

export const en: TPageTranslations<TKeys, typeof CANDIDATE_FORM> = {
  [CANDIDATE_FORM]: {
    PUBLISHED: 'Published: {{datePublished}}',
    SPACE: ' | ',
    APPLY: 'Apply',
    APPLICATION_FORM: 'Application form',
    WORK_MODE_VIRTUAL: 'Remote',
    WORK_MODE_ONSITE: 'On-site',
    WORK_MODE_HYBRID: 'Hybrid',
    CONTRACT_LEARNING: 'Apprenticeship / Internship',
    CONTRACT_FIXED: 'Fixed-term',
    CONTRACT_INDEFINITE: 'Indefinite term',
    CONTRACT_SERVICE: 'Service provision / Freelance',
    CONTRACT_WORK: 'Project-based',
    WORK_SCHEDULE_PART_TIME: 'Part-time',
    WORK_SCHEDULE_FULL_TIME: 'Full-time',
    NAMES: 'Name (s)',
    REQUIRED_ICON: ' *',
    REQUIRED_FIELDS: 'Required fields',
    LAST_NAME: 'Last name (s)',
    EMAIL: 'Email',
    NUMBER_PHONE: 'Number phone',
    DESCRIPTION_PHONE:
      'Enter your phone number using only numbers (no parentheses, dashes or spaces).',
    COUNTRY: 'Country of residence',
    CURRICULUM: 'Upload your resume',
    CURRICULUM_DESCRIPTION:
      'Upload your CV in PDF format with a maximum weight of 5Mb. Ensure that the text is selectable and not an image.',
    UPLOAD_ATTACHMENT: 'Upload file',
    LINKEDIN: 'LinkedIn',
    PLACEHOLDER_LINKEDIN: 'URL (Linkedin)',
    REQUIRED_FIELD: 'Required field',
    INVALID_EMAIL: 'Invalid email',
    MAX_LENGTH_EXCEEDED: 'Maximum length exceeded',
    YES: 'Yes',
    NO: 'No',
    SPACE_FOR_TEXT: 'Space for writing text',
    SPACE_FOR_NUMERIC: 'Space for writing number',
    SEND_APPLICATION: 'Send application',
    FILE_EXCEEDS_LIMIT:
      'The selected file exceeds the maximum weight limit of 5mb.',
    ERROR_TO_CREATE_JOB_APPLICANT_PROFILE:
      'Error to create a job applicant profile',
    ERROR_PAGE_TITLE_CANDIDATE_FORM: 'An error occurred',
    ERROR_PAGE_DESCRIPTION_CANDIDATE_FORM:
      'Click the button to try loading again.',
    RETRY: 'Retry',
    INVALID_PHONE: 'Invalid phone number',
    CANDIDATE_FORM_STATUS_TITLE_CLOSED: 'The call has ended',
    CANDIDATE_FORM_STATUS_SUBTITLE_CLOSED: '¡Thanks for your interest!',
    CANDIDATE_FORM_STATUS_DESCRIPTION_CLOSED:
      'Very soon we will be publishing new job opportunities.',
    CANDIDATE_FORM_STATUS_TITLE_SUCCESS: '¡We have received your application!',
    CANDIDATE_FORM_STATUS_SUBTITLE_SUCCESS:
      '¡Thanks for your interest in working with us!',
    CANDIDATE_FORM_STATUS_DESCRIPTION_SUCCESS:
      'Soon we will contact you about the status of your application.',
    CANDIDATE_FORM_STATUS_TITLE_NOT_FOUND: 'Form not found',
    CANDIDATE_FORM_STATUS_DESCRIPTION_NOT_FOUND: 'Try again in a few minutes',
    EMAIL_VALIDATION_TITLE:
      'This email has already been used for this application.',
    EMAIL_VALIDATION_DESCRIPTION:
      'This email has already been used for this application. Please use a different email.',
    LOADING_SEND_APPLICATION: 'Sending your application',
    INVALID_LINKEDIN_URL: 'Invalid LinkedIn URL',
    BANNER_PREVIEW_FORM:
      'This preview form is only informative, so it does not allow uploading files or sending it.',
    LINKEDIN_VALIDATION_TITLE:
      'The link you entered does not seem to be a valid LinkedIn profile',
    LINKEDIN_VALIDATION_DESCRIPTION:
      'Ensure you copy and paste a complete URL, like:',
    EMAIL_BLOCKED_VALIDATION_TITLE: 'You cannot apply to this vacancy',
    EMAIL_BLOCKED_VALIDATION_DESCRIPTION:
      'Your profile is not enabled to apply to new vacancies at this time.',

    BACK_TO_FORM: 'Back to form',
  },
};
